/**
 * Hot & Spice Theme
 * Warm and energetic palette with burnt orange and saffron accents
 */

export const hotSpiceTheme = {
  theme_name: 'Hot & Spice',
  theme_description:
    'Warm and energetic palette with burnt orange and saffron accents',
  vibe: 'Warm & Professional',

  // Colors - Warm, spice-inspired design (no purple)
  primary_color: '#EA580C', // Burnt orange for primary actions
  secondary_color: '#6B7280', // Gray for secondary elements
  accent_color: '#C2410C', // Deeper burnt orange for accents
  background_color: '#FFFFFF', // Pure white background
  surface_color: '#F9FAFB', // Very light gray for cards/surfaces
  text_color: '#111827', // Dark text for readability
  text_secondary: '#6B7280', // Secondary text
  text_muted: '#9CA3AF', // Muted text
  divider_color: '#E5E7EB', // Light dividers

  // Semantic Status Colors - Clean and vibrant
  success_color: '#10B981', // Emerald green
  error_color: '#EF4444', // Clean red
  warning_color: '#F59E0B', // Amber warning
  info_color: '#3B82F6', // Blue info

  // Typography - Modern and clean
  font_family: "'Inter', 'Helvetica Neue', 'Arial', sans-serif",
  font_size: '14px',
  heading_font_size: '2rem', // Increased from 1.5rem for better readability
  font_weight_normal: '400',
  font_weight_bold: '600',

  // Layout - Clean and minimal
  border_radius: 8,
  spacing_unit: 8,

  // Theme mode
  mode: 'light',

  // Assets
  logo_url: '',
  favicon_url: '',

  // Custom CSS for Canva-inspired design
  custom_css: ``,

  // Status
  is_active: false,
  status: 'inactive',
};

export default hotSpiceTheme;
